import { render, staticRenderFns } from "./SameNameOwnerPatientsSelectPopup.vue?vue&type=template&id=6fe1d12c&scoped=true&"
import script from "./SameNameOwnerPatientsSelectPopup.vue?vue&type=script&lang=js&"
export * from "./SameNameOwnerPatientsSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./SameNameOwnerPatientsSelectPopup.vue?vue&type=style&index=0&id=6fe1d12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1d12c",
  null
  
)

export default component.exports